import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      [theme.breakpoints.up('xs')]: {
        width: '100%',
      },
      [theme.breakpoints.up('md')]: {
        width: '100%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '100%',
      },
    },
    rightitem: {
      marginRight: 48,
    },
    tableMargin: {
      margin: 21,
    },
    input: {
      marginLeft: theme.spacing(1),
      width: '100%',
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
    btnPrimary: {
      minHeight: 38,
      height: 38,
      width: 38,
      minWidth: 38,
      textTransform: 'none',
      background:
        'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
      color: '#fff',
      '@media(min-width: 1250px)': {
        minHeight: 48,
        height: 48,
        width: 146,
        minWidth: 146,
      },
    },

    flexCenterY: {
      display: 'flex',
      alignItems: 'center',
    },
    bodycenter: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    },
    marginLeft: {
      marginLeft: 21,
      textTransform: 'none',
    },
    makeBold: {
      color: 'red',
      fontWeight: 600,
      fontFamily: 'Poppins',
    },
    mobileCard: {
      backgroundColor: '#FFFFFF',
      borderRadius: 5,
      padding: 15,
      boxShadow: '0 12px 30px rgba(15, 23, 42, 0.12)',
      marginBottom: theme.spacing(3),
    },
    cardTitle: {
      fontSize: 18,
      fontWeight: 700,
      color: '#1F2430',
      marginBottom: 12,
      fontFamily: 'Poppins',
    },
    cardDateRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      color: '#6F7489',
      marginBottom: 10,
    },
    cardDateIcon: {
      fontSize: 18,
    },
    cardDateText: {
      fontSize: 14,
      fontWeight: 500,
    },
    cardButton: {
      marginTop: theme.spacing(1.5),
      width: '100%',
      textTransform: 'none',
      fontWeight: 600,
    },
  })
);
